import { render, staticRenderFns } from "./ProgramHero.vue?vue&type=template&id=d40b5b0e&"
import script from "./ProgramHero.vue?vue&type=script&lang=js&"
export * from "./ProgramHero.vue?vue&type=script&lang=js&"
import style0 from "./ProgramHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports